export default __webpack_public_path__ + "8a1b01b68572b714cb7f365bbb429991.png";